// import React from "react";
// import { Icon } from "@iconify/react";
// import vide1 from "../../../assets/video/updated0102 (1).mp4";
// import vide2 from "../../../assets/video/Azure A9032 (online-video-cutter.com).mp4";
// import { useNavigate } from "react-router-dom";

// export default function ExploreCollection({ latestYear }) {
// 	const navigate = useNavigate();
// 	const video = {
// 		src: vide1,
// 		text: "EXPLORE GOWNS",
// 		desc: "Discover the elegance and charm of our exclusive collection.",
// 	};
// 	const video1 = {
// 		src: vide2,
// 		text: "EXPLORE GOWNS",
// 		desc: "Discover the elegance and charm of our exclusive collection.",
// 	};

// 	return (
// 		<div className="flex flex-col justify-center items-center pb-20 mt-[220px] w-full">
// 			<div className="grid md:grid-cols-2 grid-cols-1 w-full 2xl:px-28 xl:px-20 md:px-10 px-4 md:gap-5 gap-5">
// 				{/* Left Image */}
// 				<div className="relative 2xl:h-[1000px] xl:h-[700px] md:h-[700px] ms:h-[700px] h-[600px] w-full overflow-hidden group ">
// 					{/* Video Background */}
// 					<video
// 						src={video.src}
// 						autoPlay
// 						loop
// 						muted
// 						playsInline
// 						className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
// 					/>

// 					{/* Content */}
// 					<div className="absolute inset-0 flex flex-col justify-end items-center text-center p-6">
// 						<button
// 							onClick={() => navigate(`prom/${latestYear}`)}
// 							className="flex items-center justify-center gap-2 px-6 py-3 font-lora text-white text-base font-semibold rounded-full bg-[#2a4ba0]/80 hover:bg-[#1f4c94] transition duration-300 mb-3">
// 							{video.text}
// 							<Icon
// 								icon="flowbite:arrow-right-outline"
// 								width="1.8rem"
// 								height="1.8rem"
// 								className="hidden md:block"
// 							/>
// 						</button>
// 						<p className="text-gray-100 text-sm font-light leading-relaxed max-w-sm">
// 							{video.desc}
// 						</p>
// 					</div>
// 				</div>

// 				{/* Center Video Section */}
// 				<div className="relative 2xl:h-[1000px] xl:h-[700px] md:h-[700px] ms:h-[700px] h-[600px] w-full overflow-hidden group">
// 					{/* Video Background */}
// 					<video
// 						src={video1.src}
// 						autoPlay
// 						loop
// 						muted
// 						playsInline
// 						className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
// 					/>

// 					{/* Content */}
// 					<div className="absolute inset-0 flex flex-col justify-end items-center text-center p-6">
// 						<button
// 							onClick={() => navigate(`prom/${latestYear}`)}
// 							className="flex items-center justify-center gap-2 px-6 py-3 font-lora text-white text-base font-semibold rounded-full bg-[#2a4ba0]/80 hover:bg-[#1f4c94] transition duration-300 mb-3">
// 							{video1.text}
// 							<Icon
// 								icon="flowbite:arrow-right-outline"
// 								width="1.8rem"
// 								height="1.8rem"
// 								className="hidden md:block"
// 							/>
// 						</button>
// 						<p className="text-gray-100 text-sm font-light leading-relaxed max-w-sm">
// 							{video1.desc}
// 						</p>
// 					</div>
// 				</div>

// 				{/* Right Image */}
// 			</div>
// 		</div>
// 	);
// }

import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import vide1 from "../../../assets/video/updated0102 (1).mp4";
import vide2 from "../../../assets/video/Azure A9032 (online-video-cutter.com).mp4";
import { HashLink as Link } from "react-router-hash-link";

export default function ExploreCollection({ latestYear }) {
	const [apiData, setApiData] = useState([]);
	const [loading, setLoading] = useState(true);

	// Static video data as fallback
	const staticVideos = [
		{
			src: vide1,
			text: "EXPLORE GOWNS",
			desc: "Discover the elegance and charm of our exclusive collection.",
		},
		{
			src: vide2,
			text: "EXPLORE GOWNS",
			desc: "Discover the elegance and charm of our exclusive collection.",
		},
	];

	// API call useEffect
	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await fetch(
					`https://admin.monsinidress.com/api/hero-section/brand`,
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({ brand: "Azure" }),
					}
				);
				if (!response.ok) throw new Error("Failed to fetch data");
				const result = await response.json();
				console.log("API Response:", result);

				// Transform API data to match component structure
				if (result.data && result.data.length > 0) {
					const transformedData = result.data.map((item, index) => ({
						_id: item._id || `api-${index}`,
						brand: item.brand || "Collection",
						media: item.media || [],
						category: item.brand?.toLowerCase().includes("azure")
							? "evening"
							: "prom",
						transformedMedia:
							item.media?.map((mediaItem) => ({
								...mediaItem,
								url: mediaItem.url.startsWith("http")
									? mediaItem.url
									: `https://admin.monsinidress.com/${mediaItem.url}`,
							})) || [],
					}));
					console.log("Transformed Data:", transformedData);
					setApiData(transformedData);
				}
			} catch (error) {
				console.error("Error fetching data:", error);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	// Use API data if available, otherwise use static data
	const displayData = apiData.length > 0 ? apiData : staticVideos;

	console.log("Display Data:", displayData);

	if (loading) {
		return (
			<div className="flex flex-col justify-center items-center min-h-screen bg-gray-50">
				{/* Spinning Icon */}
				<Icon
					icon="svg-spinners:ring-resize"
					className="w-16 h-16 text-[#1f4c94] animate-spin-slow"
				/>

				{/* Loading Text */}
				<div className="text-xl font-semibold text-gray-700 mt-4 font-poppins">
					Loading Azure Collection...
				</div>

				{/* Optional: Simple Subtext for a better user experience */}
				<p className="text-sm text-gray-500 mt-1">
					Fetching the latest styles.
				</p>
			</div>
		);
	}

	return (
		<div className="flex flex-col justify-center items-center pb-20 mt-[220px] w-full">
			<div className="grid md:grid-cols-2 grid-cols-1 w-full 2xl:px-28 xl:px-20 md:px-10 px-4 md:gap-5 gap-5">
				{displayData.map((item, index) => (
					<div
						key={item._id || index}
						className="relative 2xl:h-[1000px] xl:h-[700px] md:h-[700px] ms:h-[700px] h-[600px] w-full overflow-hidden group">
						{/* Media Background - Handle both video and image */}
						{item.transformedMedia?.[0]?.type === "video" || item.src ? (
							<video
								src={item.transformedMedia?.[0]?.url || item.src}
								autoPlay
								loop
								muted
								playsInline
								className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
							/>
						) : (
							<img
								src={item.transformedMedia?.[0]?.url}
								alt={item.brand}
								className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
							/>
						)}

						{/* Content */}
						<div className="absolute inset-0 flex flex-col justify-end items-center text-center p-6">
							<Link
								to={`/prom/${latestYear}`}
								className="flex items-center justify-center gap-2 px-6 py-3 font-lora text-white text-base font-semibold rounded-full bg-[#2a4ba0]/80 hover:bg-[#1f4c94] transition duration-300 mb-3">
								{/* Use brand name from API or static text */}
								{apiData.length > 0
									? `EXPLORE ${item.brand?.toUpperCase()}`
									: item.text}
								<Icon
									icon="flowbite:arrow-right-outline"
									width="1.8rem"
									height="1.8rem"
									className="hidden md:block"
								/>
							</Link>
							<p className="text-gray-100 text-sm font-light leading-relaxed max-w-sm">
								{/* Use dynamic description or static fallback */}
								{apiData.length > 0
									? `Discover the latest ${item.brand} collection`
									: item.desc}
							</p>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
